export default __webpack_public_path__ + "static/media/Group 2132.f92a6ed0.png";